import React, { useEffect } from 'react';

import { useAppDispatch } from '../../hooks/redux';

import { useGetAppSettingsQuery } from '../../services/directus.api';
import { setSettings } from '../../store/appSettings.slice';

interface IAppSettingsProps {
  children: React.ReactNode;
}

const AppSettings: React.FC<IAppSettingsProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  // Only the DPDG defaults live here: fetch early, never block the app on them.
  const { data: settings, error } = useGetAppSettingsQuery();

  useEffect(() => {
    if (settings) {
      dispatch(setSettings(settings));
    }
  }, [settings, dispatch]);

  if (error) {
    console.warn('Ошибка загрузки настроек', error);
  }

  return <>{children}</>;
};

export default AppSettings;
